import React from 'react';
import { Input } from '../../ui/Input';

export interface FieldLabelInputProps {
  value: string;
  onChange: (label: string) => void;
}

/** Controlled editor do rótulo (label) de um field. Share entre desktop + mobile builder. */
export const FieldLabelInput: React.FC<FieldLabelInputProps> = ({ value, onChange }) => (
  <Input
    label="Rótulo"
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);
